import React, { useState } from "react";
import { S, CONTACT_ROLES } from "./theme";

const blank = (leadId, user) => ({
  leadId: leadId || "",
  name: "",
  role: "President",
  phone: "",
  email: "",
  notes: "",
  assignedToUid: user?.uid || "",
});

export default function ContactModal({ contact, leads, defaultLeadId, user, onSave, onClose, onDelete }) {
  const [form, setForm] = useState(contact ? { ...blank(defaultLeadId, user), ...contact } : blank(defaultLeadId, user));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSave = async () => {
    if (!form.name.trim()) { setError("Contact name is required."); return; }
    if (!form.leadId) { setError("Please link this contact to a lead."); return; }
    setSaving(true);
    setError("");
    try {
      // Keep the contact's assignedToUid in sync with its lead, so visibility
      // filtering (Sales sees only their own) stays consistent.
      const lead = leads.find((l) => l.id === form.leadId);
      await onSave({ ...form, assignedToUid: lead ? lead.assignedToUid : form.assignedToUid });
      onClose();
    } catch (e) {
      setError("Save failed: " + e.message);
    }
    setSaving(false);
  };

  return (
    <div style={S.modalOverlay} onClick={onClose}>
      <div style={S.modalBox} onClick={(e) => e.stopPropagation()}>
        <div style={S.header}>
          <div style={S.title}>{contact ? "Edit Contact" : "New Contact"}</div>
          <button style={S.btnSmall} onClick={onClose}>✕ Close</button>
        </div>

        {error && <div style={{ ...S.msg, borderColor: "#f87171", color: "#f87171" }}>{error}</div>}

        <div style={{ marginBottom: 14 }}>
          <label style={S.label}>Linked Lead / Society *</label>
          <select style={S.select} value={form.leadId} onChange={(e) => set("leadId", e.target.value)}>
            <option value="">— Select a lead —</option>
            {leads.map((l) => <option key={l.id} value={l.id}>{l.societyName}</option>)}
          </select>
        </div>

        <div style={S.formGrid}>
          <div>
            <label style={S.label}>Name *</label>
            <input style={S.input} value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="e.g. Ramesh Kumar" />
          </div>
          <div>
            <label style={S.label}>Role</label>
            <select style={S.select} value={form.role} onChange={(e) => set("role", e.target.value)}>
              {CONTACT_ROLES.map((r) => <option key={r}>{r}</option>)}
            </select>
          </div>
        </div>

        <div style={S.formGrid}>
          <div>
            <label style={S.label}>Phone</label>
            <input style={S.input} value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="10-digit mobile" />
          </div>
          <div>
            <label style={S.label}>Email</label>
            <input style={S.input} value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="name@example.com" />
          </div>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={S.label}>Notes</label>
          <textarea style={S.textarea} rows={3} value={form.notes} onChange={(e) => set("notes", e.target.value)} placeholder="Preferences, concerns, anything useful…" />
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 16 }}>
          <div>
            {contact && onDelete && (
              <button style={S.btnRed} onClick={() => onDelete(contact.id)}>Delete Contact</button>
            )}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button style={S.btnGray} onClick={onClose}>Cancel</button>
            <button style={S.btnBlue} onClick={handleSave} disabled={saving}>{saving ? "Saving…" : "Save Contact"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
